export default __webpack_public_path__ + "static/media/element_13.f97b2ceb.jpg";